import { checkVAT, germany } from "jsvat";

export function ensureVatValidation(value?: string | null): boolean {
  if (!value) {
    return true;
  }

  return checkVAT(value, [germany]).isValid;
}
